import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function useRestauranteSalones() {
  const [salones, setSalones] = useState([]);
  const [salonActivoId, setSalonActivoId] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  const cargar = useCallback(async () => {
    setCargando(true);
    setError('');

    try {
      const response = await api.get('/restaurante/salones');
      const data = Array.isArray(response.data) ? response.data : [];

      setSalones(data);

      setSalonActivoId((actual) => {
        if (actual && data.some((salon) => salon.id === actual)) {
          return actual;
        }

        return data[0]?.id ?? null;
      });
    } catch (err) {
      console.error('Error cargando salones:', err);
      setError(
        err?.response?.data?.error ||
          'No se pudieron cargar los salones.'
      );
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const salonActivo =
    salones.find((salon) => salon.id === salonActivoId) || null;

  return {
    salones,
    salonActivo,
    salonActivoId,
    setSalonActivoId,
    cargando,
    error,
    recargar: cargar,
  };
}
